module.exports = __webpack_public_path__ + "img/completeBackground.cc0269d0.png";